import type { RouteObject } from "react-router-dom";
import { addSlashes, withCompanyPrefix } from "../route.utils";
import { Spinner } from "@/components/ui/v2/spinner";
import { CompanyIntegrations } from "@/utils/lazyLoadComponents";

// ─── Path Segments ────────────────────────────────────────────────────────────
export enum COMPANY_INTEGRATIONS_PATH_SEGMENTS {
  ROOT = "integrations",
}

// ─── Route Definition ─────────────────────────────────────────────────────────
// Single landing page for now (Jira only). As more providers are added, this
// grows children the same way other modules do.
export const companyIntegrationsRoutes: RouteObject = {
  path: COMPANY_INTEGRATIONS_PATH_SEGMENTS.ROOT,
  handle: { breadcrumb: "Integrations" },
  HydrateFallback: Spinner,
  children: [{ index: true, Component: CompanyIntegrations }],
};

// ─── Resolved Paths ───────────────────────────────────────────────────────────
export const COMPANY_INTEGRATIONS_PATHS = Object.freeze({
  ROOT: withCompanyPrefix(addSlashes(COMPANY_INTEGRATIONS_PATH_SEGMENTS.ROOT)),
});
